{
  "name": "sharelock",
  "version": "0.0.0",
  "scripts": {
    "ng": "ng",
    "mock:server": "nodemon server/server.js --ext js,ts,json,html",
    "start:local": "ng serve --configuration=local-dev",
    "start:dev": "ng serve --configuration=dev",
    "start-clean:dev": "npx ng cache clean && ng serve --configuration=dev",
    "start:uat": "ng serve --configuration=uat",
    "start:prod": "ng serve --configuration=prod",
    "start:mock": "nodemon server/server.js --ext js,ts,json,html & ng serve --configuration=mock",
    "install:ci": "npm i & npm install -D tailwindcss",
    "build:dev": "ng build --configuration=dev",
    "build:uat": "ng build --configuration=uat",
    "build:prod": "ng build --configuration=prod",
    "watch": "ng build --watch --configuration=local-dev",
    "test": "ng test --watch=false --browsers Chrome",
    "test:ci": "ng test --watch=false --browsers ChromiumNoSandbox",
    "serve:ssr:sharelock": "node dist/sharelock/server/server.mjs",
    "lint": "npx eslint \"src/**/*.{js,jsx,ts,tsx,html}\" --quiet --fix",
    "format": "npx prettier \"src/**/*.{js,jsx,ts,tsx,html,css,scss}\" --write",
    "prepare": "husky",
    "updates:check": "npx npm-check-updates",
    "updates:interactive": "npx npm-check-updates -i"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^20.3.6",
    "@angular/cdk": "^20.1.0",
    "@angular/common": "^20.3.6",
    "@angular/compiler": "^20.3.6",
    "@angular/core": "^20.3.6",
    "@angular/forms": "^20.3.6",
    "@angular/material": "^20.1.0",
    "@angular/material-moment-adapter": "^20.1.0",
    "@angular/platform-browser": "^20.3.6",
    "@angular/platform-browser-dynamic": "^20.3.6",
    "@angular/platform-server": "^20.3.6",
    "@angular/router": "^20.3.6",
    "@angular/ssr": "^20.3.6",
    "@cospired/i18n-iso-languages": "^4.2.0",
    "@ngx-translate/core": "^16.0.4",
    "@ngx-translate/http-loader": "^16.0.1",
    "express": "^5.1.0",
    "file-saver": "^2.0.5",
    "i18n-iso-countries": "^7.14.0",
    "json-server": "^0.17.4",
    "jszip": "^3.10.1",
    "ngx-mask": "^19.0.6",
    "ngx-quill": "^28.0.1",
    "ngx-translate-multi-http-loader": "^19.0.3",
    "npm-check-updates": "^17.1.18",
    "quill": "^2.0.3",
    "rxjs": "~7.8.2",
    "swiper": "^11.2.6",
    "tslib": "^2.8.1",
    "uuid": "^11.1.0",
    "zone.js": "~0.15.0"
  },
  "devDependencies": {
    "@angular-eslint/builder": "^19.0.2",
    "@angular-eslint/eslint-plugin": "^19.0.2",
    "@angular-eslint/eslint-plugin-template": "^19.0.2",
    "@angular-eslint/schematics": "^19.0.2",
    "@angular-eslint/template-parser": "^19.0.2",
    "@angular/build": "^20.3.6",
    "@angular/cli": "^20.3.6",
    "@angular/compiler-cli": "^20.3.6",
    "@eslint/eslintrc": "^3.3.1",
    "@eslint/js": "^9.25.0",
    "@types/express": "^5.0.1",
    "@types/file-saver": "^2.0.7",
    "@types/jasmine": "~5.1.7",
    "@types/node": "^22.14.1",
    "@types/uuid": "^10.0.0",
    "@typescript-eslint/eslint-plugin": "^8.0.0",
    "@typescript-eslint/parser": "^8.0.1",
    "autoprefixer": "^10.4.21",
    "eslint": "^9.25.0",
    "eslint-config-prettier": "^10.1.2",
    "eslint-plugin-prettier": "^5.2.6",
    "husky": "^9.1.7",
    "jasmine-core": "^5.6.0",
    "karma": "~6.4.4",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.1",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "lint-staged": "^15.5.1",
    "nodemon": "^3.1.9",
    "postcss": "^8.5.3",
    "prettier": "^3.5.3",
    "prettier-plugin-tailwindcss": "^0.6.11",
    "tailwindcss": "^3.4.3",
    "typescript": "^5.8.3"
  }
}
